import { HobClearanceUI } from "./HobClearanceUI";
import { StandardProps } from "../componentMap";
import { getAttributeValues } from "../../utils/product/getAttributeValues";

export function HobClearance({ product }: Pick<StandardProps, "product">) {
  const hobClearanceValues = getAttributeValues(
    "minimumhobclearance",
    product.attributes ?? [],
  );
  // @ts-ignore
  return <HobClearanceUI hobClearance={hobClearanceValues[0]} />;
}
